import { BulkReachoutTemplateVersion } from "@shared/lib/types/pricingWorkload";
import { Input, Select } from "@shared/ui";
import styles from "./BulkReachoutTemplateFields.module.scss";

type BulkReachoutTemplateFieldsProps = {
  templateVersion: BulkReachoutTemplateVersion;
  product: string;
  timeline: string;
  additionalMessage: string;
  separateDeliverables: string[];
  onProductChange: (value: string) => void;
  onTimelineChange: (value: string) => void;
  onAdditionalMessageChange: (value: string) => void;
  onSeparateDeliverablesChange: (value: string[]) => void;
};

export function BulkReachoutTemplateFields({
  templateVersion,
  product,
  timeline,
  additionalMessage,
  separateDeliverables,
  onProductChange,
  onTimelineChange,
  onAdditionalMessageChange,
  onSeparateDeliverablesChange,
}: BulkReachoutTemplateFieldsProps) {
  if (templateVersion === "v1") {
    return null;
  }

  return (
    <div className={styles.fields}>
      <label className={styles.field}>
        <span className={styles.fieldLabel}>Product (optional)</span>
        <Input
          value={product}
          onChange={(event) => onProductChange(event.target.value)}
          placeholder="Enter product"
        />
      </label>

      <label className={styles.field}>
        <span className={styles.fieldLabel}>Timeline (optional)</span>
        <Input
          value={timeline}
          onChange={(event) => onTimelineChange(event.target.value)}
          placeholder="Enter timeline"
        />
      </label>

      {templateVersion === "v3" ? (
        <label className={styles.field}>
          <span className={styles.fieldLabel}>
            Separate deliverables (optional)
          </span>
          <Select
            mode="tags"
            value={separateDeliverables}
            onChange={(value) =>
              onSeparateDeliverablesChange(value as string[])
            }
            placeholder="Type a deliverable and press Enter"
            tokenSeparators={[","]}
            notFoundContent={null}
          />
        </label>
      ) : null}

      <label className={styles.field}>
        <span className={styles.fieldLabel}>Additional message (optional)</span>
        <Input.TextArea
          value={additionalMessage}
          onChange={(event) => onAdditionalMessageChange(event.target.value)}
          placeholder="Add extra notes for the creator"
          rows={3}
        />
      </label>
    </div>
  );
}
